<template>
  <div class="card card-box" style="height: 100%">
    <div class="card-body p-5">
      <!-- Image Profile -->
      <div class="row">
        <div class="col-md-12">
          <h6 class="text-center mb-2">Profil Staff</h6>
          <div class="profile d-flex justify-content-center">
            <div class="profile-custom">
              <img :src="imgURL" alt="" srcset="" />
              <div
                class="delete_photo"
                v-if="
                  this.imgURL !== '/img/hospital.png' &&
                    this.imgURL !== '/img/doctor.png' &&
                    imgURL !== null
                "
                @mouseover="isDropPhoto = true"
                @mouseleave="isDropPhoto = false"
                @click="deletePhoto()"
              >
                <font-awesome-icon
                  class="icon-times"
                  v-show="isDropPhoto"
                  icon="times"
                />
              </div>
              <b-button
                class="__btn_add_photo"
                type="file"
                @click="$refs.pictureInput.onClick()"
                ><font-awesome-icon
                  icon="camera"
                  class="text-white-50 __icon_add_photo"
              /></b-button>
            </div>
            <template>
              <picture-input
                style="display:none"
                class="inputPhoto"
                ref="pictureInput"
                :disabled="btnDisable == true"
                :customStrings="{
                  fileSize: 'File maksimal foto 1 mb',
                  fileType: 'Jenis file ini tidak didukung'
                }"
                :alertOnError="false"
                :zIndex="1"
                size="2"
                width="130"
                height="125"
                radius="50"
                :hideChangeButton="true"
                @change="onChangeImage($event)"
                :prefill="imgURL"
              />
            </template>
          </div>
          <h5 class="font-weight-bold text-center mt-2">
            {{ oldName }}
          </h5>
          <p class="text-right" style="font-size: 10pt; color: #5d5d5d;">
            Foto yang diunggah maksimal 2Mb. <br />
            dengan format file antara lain PNG, JPG, dan JPEG
          </p>
        </div>
      </div>
      <!-- End Image Profile -->

      <!-- Infor Profile -->
      <div class="wrapper-perawat-apoteker" v-if="isPerawat && isApoteker">
        <div class="row">
          <div class="col-md-6">
            <b-form-group>
              <label for="">Nama Staff<span style="color:red">*</span></label>
              <b-form-input
                :disabled="!btnDisable"
                type="text"
                maxlength="50"
                v-model="formProfile.name"
                @input="inputName($event)"
              ></b-form-input>
              <span style="color:red" v-if="formProfile.errors.name.message">
                {{ formProfile.errors.name.message }}
              </span>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group>
              <label for="">No. STR<span style="color:red">*</span></label>
              <b-form-input
                :disabled="!btnDisable"
                type="text"
                v-model="formProfile.noStr"
                @input="inputNoStr($event)"
              ></b-form-input>
              <span style="color:red" v-if="formProfile.errors.noStr.message">
                {{ formProfile.errors.noStr.message }}
              </span>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <b-form-group>
              <label for=""
                >No. Handphone<span style="color:red">*</span></label
              >
              <b-form-input
                :disabled="!btnDisable"
                type="text"
                maxlength="50"
                v-model="formProfile.handphone"
                @keypress="keypressHandphone($event)"
                @input="inputHandphone($event)"
              ></b-form-input>
              <span
                style="color:red"
                v-if="formProfile.errors.handphone.message"
              >
                {{ formProfile.errors.handphone.message }}
              </span>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group>
              <label for="">No. SIPA<span style="color:red">*</span></label>
              <b-form-input
                :disabled="!btnDisable"
                type="text"
                v-model="formProfile.noSipa"
                @input="inputNoSipa($event)"
              ></b-form-input>
              <span style="color:red" v-if="formProfile.errors.noSipa.message">
                {{ formProfile.errors.noSipa.message }}
              </span>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <b-form-group>
                  <label for="">Email<span style="color:red">*</span></label>
                  <b-form-input
                    :disabled="!btnDisable"
                    type="text"
                    maxlength="50"
                    v-model="formProfile.email"
                    @input="inputEmail($event)"
                  ></b-form-input>
                  <span
                    style="color:red"
                    v-if="formProfile.errors.email.message"
                  >
                    {{ formProfile.errors.email.message }}
                  </span>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-12 mb-3">
            <b-button
              variant="primary"
              v-if="btnDisable"
              class="float-right"
              @click="onSubmit"
              >SIMPAN DATA</b-button
            >
            <b-button
              variant="primary"
              v-if="!btnDisable"
              @click="btnDisable = true"
              class="float-right"
              >EDIT DATA</b-button
            >
          </div>
        </div>
      </div>
      <div class="wrapper-perawat-apoteker" v-else>
        <div class="row">
          <div class="col-md-6">
            <b-form-group>
              <label for="">Nama Staff<span style="color:red">*</span></label>
              <b-form-input
                :disabled="!btnDisable"
                type="text"
                maxlength="50"
                v-model="formProfile.name"
                @input="inputName($event)"
              ></b-form-input>
              <span style="color:red" v-if="formProfile.errors.name.message">
                {{ formProfile.errors.name.message }}
              </span>
            </b-form-group>
          </div>
          <div class="col-md-6" v-if="isPerawat">
            <b-form-group>
              <label for="">No. STR<span style="color:red">*</span></label>
              <b-form-input
                :disabled="!btnDisable"
                type="text"
                v-model="formProfile.noStr"
                @input="inputNoStr($event)"
              ></b-form-input>
              <span style="color:red" v-if="formProfile.errors.noStr.message">
                {{ formProfile.errors.noStr.message }}
              </span>
            </b-form-group>
          </div>
          <div class="col-md-6" v-else-if="isApoteker">
            <b-form-group>
              <label for="">No. SIPA<span style="color:red">*</span></label>
              <b-form-input
                :disabled="!btnDisable"
                type="text"
                v-model="formProfile.noSipa"
                @input="inputNoSipa($event)"
              ></b-form-input>
              <span style="color:red" v-if="formProfile.errors.noSipa.message">
                {{ formProfile.errors.noSipa.message }}
              </span>
            </b-form-group>
          </div>
          <div class="col-md-6" v-else>
            <div class="row">
              <div class="col-md-12">
                <b-form-group>
                  <label for="">Email<span style="color:red">*</span></label>
                  <b-form-input
                    :disabled="!btnDisable"
                    type="text"
                    maxlength="50"
                    v-model="formProfile.email"
                    @input="inputEmail($event)"
                  ></b-form-input>
                  <span
                    style="color:red"
                    v-if="formProfile.errors.email.message"
                  >
                    {{ formProfile.errors.email.message }}
                  </span>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <b-form-group>
              <label for=""
                >No. Handphone<span style="color:red">*</span></label
              >
              <b-form-input
                :disabled="!btnDisable"
                type="text"
                maxlength="50"
                v-model="formProfile.handphone"
                @keypress="keypressHandphone($event)"
                @input="inputHandphone($event)"
              ></b-form-input>
              <span
                style="color:red"
                v-if="formProfile.errors.handphone.message"
              >
                {{ formProfile.errors.handphone.message }}
              </span>
            </b-form-group>
          </div>
          <div class="col-md-6" v-if="isPerawat && !isAPoteker || isApoteker && !isPerawat">
            <div class="row">
              <div class="col-md-12">
                <b-form-group>
                  <label for="">Email<span style="color:red">*</span></label>
                  <b-form-input
                    :disabled="!btnDisable"
                    type="text"
                    maxlength="50"
                    v-model="formProfile.email"
                    @input="inputEmail($event)"
                  ></b-form-input>
                  <span
                    style="color:red"
                    v-if="formProfile.errors.email.message"
                  >
                    {{ formProfile.errors.email.message }}
                  </span>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-12 mb-3">
            <b-button
              variant="primary"
              v-if="btnDisable"
              class="float-right"
              @click="onSubmit"
              >SIMPAN DATA</b-button
            >
            <b-button
              variant="primary"
              v-if="!btnDisable"
              @click="btnDisable = true"
              class="float-right"
              >EDIT DATA</b-button
            >
          </div>
        </div>
      </div>
      <!-- End Info Profile -->
    </div>
  </div>
</template>

<script>
import PictureInput from "vue-picture-input";
import axios from "axios";
import { mapGetters } from "vuex";
import { counter, library } from "@fortawesome/fontawesome-svg-core";
import {
  faInfo,
  faFolder,
  faCamera,
  faTimes,
  faCalendar
} from "@fortawesome/free-solid-svg-icons";
library.add(faInfo, faCamera, faFolder, faTimes, faCalendar);
import { EventBus } from "../../../event-bus";

import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import moment from "moment";
locale.use(lang);

export default {
  components: {
    PictureInput
  },
  data() {
    return {
      imgURL: "",
      activeTab: "profile",
      isDropPhoto: null,
      btnDisable: false,

      formProfile: {
        name: "",
        handphone: "",
        noSipa: "",
        noStr: "",
        email: "",
        sipFile: "",
        errors: null
      },
      oldEmail: null,
      oldName: null,
      oldSipa: null,
      oldStr: null,
      marginTop: "-100px"
    };
  },
  created() {
    this.getProfile();
    this.buildErrorMessage();
  },
  mounted() {
    if (this.$refs.pictureInput.file != undefined) {
      this.isDefault = false;
    }

    window.swal = this.$swal;
    const inputFiles = document.querySelector(".inputPhoto").childNodes[1];

    inputFiles.addEventListener("change", () => {
      const imgFile = inputFiles.files[0];

      const allowedImg = ["jpeg", "jpg", "png"];
      const imgType = imgFile.name.split(".").slice(-1)[0];

      if (!allowedImg.includes(imgType.toLowerCase())) {
        window.swal({
          type: "warning",
          title: "Foto Gagal Disimpan",
          text: "Foto yang Diunggah Tidak Sesuai Format.",
          width: "800px",
          allowOutsideClick: false
        });
        return;
      }

      if (imgFile.size > 2097152) {
        window.swal({
          type: "warning",
          title: "Foto Gagal Disimpan",
          text: "Maksimal Ukuran Gambar 2 MB!",
          width: "800px",
          allowOutsideClick: false
        });
        return;
      }
    });

    window.scrollTo({ top: 0, behavior: "smooth" });
  },
  computed: {
    ...mapGetters(["getKlinikId", "getRolesName", "getFaskesType"]),
    isPic() {
      return /pic/.test(this.getRolesName);
    },
    isDokter() {
      const condition1 = /dokter/.test(this.getRolesName);

      return condition1;
    },
    isStaff() {
      return (
        this.isPerawat || this.isFrontDesk || this.isKasir || this.isApoteker
      );
    },
    isPerawat() {
      const condition1 = /perawat/.test(this.getRolesName);

      return condition1;
    },
    isFrontDesk() {
      const condition1 = /frontdesk/.test(this.getRolesName);

      return condition1;
    },
    isKasir() {
      const condition1 = /kasir/.test(this.getRolesName);

      return condition1;
    },
    isApoteker() {
      const condition1 = /apoteker/.test(this.getRolesName);

      return condition1;
    },
    isDpm() {
      return this.getFaskesType;
    }
  },
  watch: {},
  methods: {
    buildErrorMessage() {
      this.formProfile.errors = {
        status: false,
        name: {
          error: false,
          message: ""
        },
        handphone: {
          error: false,
          message: ""
        },
        noSipa: {
          error: false,
          message: ""
        },
        noStr: {
          error: false,
          message: ""
        },
        email: {
          error: false,
          message: ""
        },
        sipFile: {
          error: false,
          message: ""
        }
      };
    },
    selectTab(menu) {
      this.activeTab = menu;
    },
    async getProfile() {
      try {
        let profile;
        this.imgURL = "";

        profile = this.$store.state.user.id;

        const res = await axios.get(
          `${this.url_api}/klinik/user/${profile}?klinik_id=${this.getKlinikId}`
        );

        const { data } = res.data;
        const klinik = data.klinik_user[0].klinik;
        const name = data.nama;

        this.oldStr = data.no_str;
        this.oldSipa = data.no_sipa;

        this.formProfile = {
          ...this.formProfile,
          name: data.nama || "-",
          noStr: data.no_str || "-",
          email: data.email || "-",
          handphone: data.nomor_telp || "-",
          noSipa: data.no_sipa || "-",
          alamat: data.alamat || "-"
        };
        this.oldEmail = data.email;
        this.oldHandphone = data.nomor_telp;
        this.oldName = name;

        if (data.foto_profile == null) {
          this.imgURL = "/img/doctor.png";
        } else {
          this.imgURL = data.foto_profile;
        }

        EventBus.$emit("count-schedule", 0);
      } catch (error) {
        // console.log(error);
      }
    },
    hasFeatures(value) {
      const features = {
        manajemen: ["owner_klinik", "manajemen"],
        klinik: ["pic_cabang", "pic_pusat"],
        dokter: ["dokter_klinik"]
      };
      const isOwner = features[value].filter(feature => {
        return this.getRolesName.includes(feature);
      });
      return isOwner.length > 0 ? true : false;
    },
    errorImagePopUp(message) {
      this.$swal({
        type: "warning",
        title: "Foto Gagal Disimpan",
        text: message,
        width: "800px",
        allowOutsideClick: false
      });
      this.$refs.pictureInput.file = null;
      this.$refs.pictureInput.image = null;
      this.$refs.pictureInput.fileModified = null;
      this.$refs.pictureInput.fileName = null;
      this.$refs.pictureInput.fileSize = null;
      this.$refs.pictureInput.fileType = null;
    },
    onChangeImage(image) {
      let formData = new FormData();
      let imgFile = this.$refs.pictureInput.file;

      const allowedImg = ["jpeg", "jpg", "png"];
      const imgType = imgFile.name.split(".").slice(-1)[0];

      if (!allowedImg.includes(imgType.toLowerCase())) {
        this.errorImagePopUp("File yang Diunggah Tidak Sesuai Format");
        return;
      }

      if (imgFile.size > 2097152) {
        this.errorImagePopUp("Maksimal Ukuran Gambar 2 MB!");
        return;
      }

      formData.append("klinik_id", this.getKlinikId);
      formData.append("file", this.$refs.pictureInput.file);
      formData.append("type", "user");

      if (image) {
        const profile = this.$store.state.user.id;

        axios
          .post(`${this.url_api}/klinik/upload/photo/${profile}`, formData, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          })
          .then(respononse => {
            this.$swal({
              type: "success",
              title: "Update Foto Profil Berhasil",
              text: "Foto Profil Berhasil Disimpan",
              allowOutsideClick: false
            });
            this.imgURL = respononse.data.data.url;
            this.isDropPhoto = false;
            EventBus.$emit("image-uploaded", true);
          });
      }
    },

    deletePhoto() {
      try {
        let formData = new FormData(),
          profile = this.$store.state.user.id;

        formData.append("klinik_id", this.getKlinikId);
        formData.append("type", "user");

        axios
          .post(`${this.url_api}/klinik/delete-photo/${profile}`, formData, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          })
          .then(() => {
            this.imgURL = "/img/doctor.png";

            EventBus.$emit("image-uploaded", true);
          });
      } catch (error) {
        // console.log(error)
      }
    },
    inputEmail(value) {
      this.removeErrorField("email");

      if (!value) {
        this.addErrorField("email", `Email harus diisi`);
        return;
      }

      if (
        value.match(
          /^([A-Za-z][A-Za-z0-9\-\.\_\+]*)\@([A-Za-z][A-Za-z0-9\-\_\+]*)(\.[A-Za-z][A-Za-z0-9\-\_\+]*)+$/
        ) == null
      ) {
        this.addErrorField("email", "Format email salah");
        return;
      } else {
        this.removeErrorField("email");
      }

      if (value == this.oldEmail) return;

      if (this._timeoutEmail) clearTimeout(this._timeoutEmail);

      this._timeoutEmail = setTimeout(() => {
        axios
          .get(`${this.url_api}/email/verify?tipe_faskes=1&email=${value}`)
          .then(response => {
            if (response.data.status == false) {
              this.addErrorField("email", "Email sudah digunakan");
            } else {
              this.removeErrorField("email");
            }
          })
          .catch(error => {})
          .finally(() => {
            clearTimeout(this._timeoutEmail);
          });
      }, 600);
    },
    keypressHandphone(evt) {
      evt = evt ? evt : window.event;

      if (evt.target.value.length > 14) {
        evt.preventDefault();
      }

      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    inputHandphone(value) {
      this.removeErrorField("handphone");

      if (!value) {
        this.addErrorField("handphone", `No. Handphone harus diisi`);
        return;
      }

      if (value.length <= 8 || value.length > 15) {
        this.addErrorField("handphone", "No. Handphone Minimal 9 Karakter");
        return;
      } else {
        this.removeErrorField("handphone");
      }

      if (value == this.oldHandphone) return;

      if (this._timeoutEmail) clearTimeout(this._timeoutEmail);

      this._timeoutEmail = setTimeout(() => {
        axios
          .get(`${this.url_api}/phone/verify?tipe_faskes=1&nomor_telp=${value}`)
          .then(response => {
            if (response.data.status == false) {
              this.addErrorField("handphone", "No.Handphone telah terdaftar");
            } else {
              this.removeErrorField("handphone");
            }
          })
          .catch(error => {})
          .finally(() => {
            clearTimeout(this._timeoutEmail);
          });
      }, 600);
    },
    inputName(value) {
      this.removeErrorField("name");
      if (!value) {
        this.addErrorField("name", `Nama Staff harus diisi`);
        return;
      }
    },
    inputAlamat(value) {
      this.removeErrorField("alamat");
      // if (!value) {
      //   this.addErrorField("alamat", `Alamat harus diisi`);
      //   return;
      // }
    },
    inputNoStr(value) {
      this.removeErrorField("noStr");

      if (!value || value == '-') {
        this.addErrorField("noStr", `No. STR harus diisi`);
        return;
      }

      // if (value == this.oldStr) return;

      // if (this._timeoutNoStr) clearTimeout(this._timeoutNoStr);

      // const path = `klinik/user/check-str?column=no_str&value=${value}`;

      // this._timeoutNoStr = setTimeout(() => {
      //   axios.post(`${this.url_api}/${path}`)
      //     .then(response => {
      //       if (response.data.status == false) {
      //         this.addErrorField("noStr", `No. STR sudah digunakan`);
      //       } else {
      //         this.removeErrorField("noStr");
      //       }
      //     })
      //     .catch(error => {})
      //     .finally(() => {
      //       clearTimeout(this._timeoutNoStr);
      //     });
      // }, 600);
    },
    inputNoSipa(value) {
      this.removeErrorField("noSipa");

      if (!value || value == '-') {
        this.addErrorField("noSipa", `No. SIPA harus diisi`);
        return;
      }

      if (value == this.oldSipa) return;

      // if (this._timeoutEmail) clearTimeout(this._timeoutEmail);

      // const path = `klinik/user/check-sipa?column=no_sipa&value=${value}`;

      // this._timeoutEmail = setTimeout(() => {
      //   axios.post(`${this.url_api}/${path}`)
      //     .then(response => {
      //       if (response.data.status == false) {
      //         this.addErrorField("noSipa", `No. SIPA sudah digunakan`);
      //       } else {
      //         this.removeErrorField("noSipa");
      //       }
      //     })
      //     .catch(error => {})
      //     .finally(() => {
      //       clearTimeout(this._timeoutEmail);
      //     });
      // }, 600);
    },

    addErrorField(field, message) {
      this.formProfile.errors.status = true;
      this.formProfile.errors[field] = {
        error: true,
        message
      };
    },
    removeErrorField(field) {
      this.formProfile.errors[field] = {
        error: false,
        message: ""
      };
    },
    requiredValidation() {
      const field = ["name", "handphone", "email"];
      const fieldLabel = ["Nama", "No. Handphone", "email"];

      if (this.isPerawat) {
        field.push("noStr");
        fieldLabel.push("Nomor STR");
      }

      if (this.isApoteker) {
        field.push("noSipa");
        fieldLabel.push("Nomor SIPA");
      }

      for (const [index, attr] of field.entries()) {
        if (!this.formProfile[attr] || this.formProfile[attr] == '-') {
          this.addErrorField(attr, `${fieldLabel[index]} harus diisi`);
        }
      }
    },
    errorExist() {
      const errors = Object.assign({}, this.formProfile.errors);
      delete errors.status;

      for (const attr in errors) {
        if (errors[attr].message) {
          return true;
        }
      }
    },
    onSubmit() {
      this.requiredValidation();

      if (this.errorExist()) {
        return;
      }

      let payload = {
        ...this.formProfile,
        oldEmail: this.oldEmail,
        klinik_id: this.getKlinikId,
        user_id: this.$store.state.user.id,
        isStaff: this.isStaff
      };

      const isEmailSame = payload.email ? this.oldEmail == payload.email : true;

      axios
        .post(`${this.url_api}/klinik/profile/user`, payload)
        .then(response => {
          if (!isEmailSame)
            this.$store.commit(
              "SET_VERIFICATION_PROFILE_ID",
              response.data.data.id
            );

          if (response.data.status) {
            this.$swal({
              type: "success",
              title: "Update Data Informasi Berhasil",
              text: "Data Informasi Berhasil Disimpan",
              width: "700px",
              allowOutsideClick: false
            }).then(result => {
              if (result.value) {
                if (isEmailSame) {
                  EventBus.$emit("image-uploaded", true);
                  this.btnDisable = false;
                  this.getProfile();
                  // this.$router.push({ name: "account-setting" });
                } else {
                  this.$router.push({
                    name: "account-setting-verification-code"
                  });
                }
              }
            });
          } else {
            throw new Error("failed");
          }
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Simpan Data Informasi Pengguna",
            text: "Simpan Data Informasi Pengguna Gagal",
            width: "700px"
          });
        });
    }
  }
};
</script>
<style>
#faskesProfile {
  transform: scale(0.78);
  width: 128%;
  margin-left: -14%;
  /* margin-top: -100px; */
  font-size: 12pt;
}

.v-tooltip .tooltip-inner {
  background: #ffffff !important;
  color: #858585 !important;
}

.v-tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #ffffff;
  z-index: 1;
}
</style>
<style scoped>
.__blue {
  color: #4b80b6;
}
.__icon_add_photo {
  position: absolute;
  top: 12px;
  left: 14px;
}
.__btn_add_photo {
  position: absolute;
  top: 85px;
  right: -20px;
  z-index: 20;
  border-radius: 50%;
  height: 44px !important;
  background-color: rgb(121, 121, 121);
}
.delete_photo {
  position: absolute;
  width: 100%;
  height: 20%;
  top: 30%;
  z-index: 9;
  font-size: 30pt;
  text-align: center;
}
.profile-custom {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  position: relative;
  border: 1px solid #cdcdcd;
}

.profile-custom img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.bg-disable {
  background: #eeeff8;
}

.bg-enable {
  background: #ffffff;
}

.sip-file {
  height: 130px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #cdcdcd;
}

.btn-calander {
  box-shadow: none;
}
</style>
